import { createSelector } from '@ngrx/store';

import { getCategoryState } from '../category-page.selectors';
import { CategoryState } from '../category-page.state';

export const getGridType = createSelector(getCategoryState, (state: CategoryState) => state?.gridType);
